import { Box, Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, IconButton, TextField } from '@mui/material';
import { useState } from 'react';
import CloseIcon from '@mui/icons-material/Close';
import { Controller, useForm } from 'react-hook-form';

export const CommentDialog = ({ onSubmit }) => {
    const [open, setOpen] = useState(false);
    const { control, reset, getValues, formState: { errors, isDirty, isValid } } = useForm({
        mode: 'onChange',
        defaultValues: {
            comment: ''
        }
    })

    const handleClickOpen = () => {
        setOpen(true);
    };

    const handleClose = () => {
        setOpen(false);
    };

    const handleAccept = async () => {
        await onSubmit(getValues('comment'))
        handleClose()
        reset();
    };

    const handleReject = () => {
      handleClose();
    };

    return (
        <Box >
            <Button variant='contained' color="primary" onClick={handleClickOpen}>Add Comment</Button>
            <Dialog open={open} onClose={handleClose} fullWidth>
                <DialogTitle>Doctor Comments Form
                    <IconButton style={{ position: 'absolute', right: '8px', top: '8px' }} onClick={handleClose}>
                        <CloseIcon />
                    </IconButton></DialogTitle>
                <DialogContent >
                    <DialogContentText>
                        Please enter your comments below:
                    </DialogContentText>
                    <Controller
                        name="comment"
                        control={control}
                        rules={{ required: "Comment is required" }}
                        render={({ field }) => (<TextField
                            {...field}
                            autoFocus
                            margin="dense"
                            label="Comments"
                            multiline
                            rows={4}
                            fullWidth
                            error={errors["comment"] ? true : false}
                            helperText={errors["comment"] ? errors["comment"].message : ""}
                        />)}
                    />
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleReject} color="primary"  disabled={!isValid || !isDirty}>
                        Cancel
                    </Button>
                    <Button onClick={handleAccept} color="primary"  disabled={!isValid || !isDirty}>
                        Add Comment
                    </Button>
                </DialogActions>
            </Dialog>
        </Box>
    );
};

export default CommentDialog;